module.exports = __webpack_public_path__ + "media/images/posts/chess-3773f92adc317bf8b8cfb8b3b12a9074.jpg";